export const NON_DURATION_CONFIRMATION_TYPES_DISPLAY_MAPPING = {
  MANUAL_RELEASE: "On-Vehicle Release",
  CLOUD_RELEASE_CONFIRMATION: "On Cloud Release",
  DURATION_RELEASE: "Countdown",
  CLOUD_HMI_RELEASE_CONFIRMATION: "Double Confirm",
  CONFIRMATION_TYPE_NONE: "None",
};

export const CONFIRMATION_TYPES = {
  DURATION_RELEASE: "DURATION_RELEASE",
  MANUAL_RELEASE: "MANUAL_RELEASE",
  CLOUD_RELEASE_CONFIRMATION: "CLOUD_RELEASE_CONFIRMATION",
  CLOUD_HMI_RELEASE_CONFIRMATION: "CLOUD_HMI_RELEASE_CONFIRMATION",
  CONFIRMATION_TYPE_NONE: "CONFIRMATION_TYPE_NONE",
};

export const TRIGGER_TYPES = {
  DURATION: "DURATION",
  HMI_BUTTON: "HMI_BUTTON",
  DOUBLE_CONFIRMATION: "DOUBLE_CONFIRMATION",
};

export const TRIGGER_TYPES_DISPLAY_MAPPING = {
  DURATION: "Duration",
  HMI_BUTTON: "HMI Button",
  DOUBLE_CONFIRMATION: "Double confirmation",
};

export type ConfirmationType = keyof typeof CONFIRMATION_TYPES;
